import type { CatalogImage } from '@/types/catalog/common'

export function buildGalleryImageUrl(image?: CatalogImage | null, width = 500): string | undefined {
  const pixlId = image?.pixl_id?.trim()
  const prefix = image?.prefix?.trim()
  if (!pixlId || !prefix) {
    return undefined
  }

  return `https://contents.mediadecathlon.com/${prefix}${pixlId}/default.webp?format=auto&f=${width}x0`
}
